export default "__VITE_ASSET__w4x$gN5A__"